import { FC } from 'react';
import {Box, Grid, styled, Typography } from '@mui/material';
import { MainTitle } from 'components/common/Title';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';

const Text = styled(Typography)(({ theme }) => ({
    fontStyle: 'normal',
    fontWeight: '400',
    // fontFamily: 'Open Sans',
    color: theme.palette.text.primary,
    fontSize: '18px',
    lineHeight: '20px',
    maxWidth: '100%',
    lineWidth: '500px',
    textWrap: 'wrap',
    textAlign: 'left',
    whiteSpace: "pre-line",
    // textWrap: 'wrap',
    wordBreak: 'break-word',
    // overflow: 'break-word',
    nowrap: false,
    // textOverflow: "ellipsis",
    // overflowWrap: 'break-word',
    // wordBreak: "break-word",
    [theme.breakpoints.up('xs')]: {
      fontSize: '16px',
    },
    [theme.breakpoints.up('sm')]: {
    },
  }));

interface Props {
    children?: React.ReactNode,
    data: any
}

const TitledInfoBox: FC<Props> = ({ children, data, ...props }) => {
    return (
        <Box mt={2} gap='5px' display='flex' flexDirection='column' sx={{padding: '10px', width: '100%'}}>
            <MainTitle textAlign='left' padding='0' fontSizeXs='20px'>{data?.title}</MainTitle>
            <Box display='flex' gap='15px' flexDirection='column' sx={{border: '0px solid red', padding: '5px'}}>
                    <>{data?.values && data?.values
                        .map((value: any) =>  
                            <Text> {value}</Text>
                    )}</> 
  
            </Box>
        </Box>
    );
}

export { TitledInfoBox };
